/**
 * Intake-classifier API client.
 *
 * Backed by /intake/stats and /intake/classifications. The
 * intake page polls these (5s) for a live-stream feel — we'll
 * upgrade to NATS-over-WS push when the operator-page becomes
 * the daily driver. Polling keeps the change small for now.
 */

import { api, type RequestOptions } from "./client";


export interface IntakeStatsDto {
  window_hours:    number;
  total:           number;
  orders:          number;
  spam:            number;            // not_order + low_confidence
  extraction_fail: number;
  empty:           number;
  total_cost_usd:  number;
  avg_latency_ms:  number;
  by_channel:      Record<string, number>;
}


export interface ClassificationDto {
  id:                UUIDString;
  channel:           string;
  channel_thread_id: string | null;
  raw_text:          string | null;
  is_order:          boolean;
  confidence:        number;
  model_first_pass:  string | null;
  model_extract:     string | null;
  cost_usd:          number;
  latency_ms:        number;
  extracted_fields:  Record<string, unknown>;
  drop_reason:       string | null;
  order_id:          UUIDString | null;
  created_at:        string;          // ISO Z
}


type UUIDString = string;


export const intakeApi = {
  stats(windowHours: number = 24, opts?: RequestOptions): Promise<IntakeStatsDto> {
    return api.get<IntakeStatsDto>(`/intake/stats?window_hours=${windowHours}`, opts);
  },

  list(
    params: { limit?: number; onlyOrders?: boolean; channel?: string } = {},
    opts?: RequestOptions,
  ): Promise<ClassificationDto[]> {
    const q = new URLSearchParams();
    q.set("limit", String(params.limit ?? 100));
    if (params.onlyOrders) q.set("only_orders", "true");
    if (params.channel)    q.set("channel", params.channel);
    return api.get<ClassificationDto[]>(`/intake/classifications?${q.toString()}`, opts);
  },
};
